export const stocksTickerSymobols = [
  [
    "AACG",
    "AACI",
    "AACIU",
    "AACIW",
    "AADI",
    "AAL",
    "AAME",
    "AAOI",
    "AAON",
    "AAPL",
    "AAWW",
    "ABCB",
    "ABCL",
    "ABCM",
    "ABEO",
    "ABGI",
    "ABIO",
    "ABNB",
    "ABOS",
    "ABSI",
    "ABST",
    "ABUS",
    "ABVC",
    "ACAB",
    "ACABW",
    "ACAC",
    "ACACU",
    "ACACW",
    "ACAD",
    "ACAH",
    "ACAHU",
    "ACAHW",
    "ACAX",
    "ACAXR",
    "ACAXU",
    "ACAXW",
    "ACB",
    "ACBA",
    "ACBAU",
    "ACBAW",
    "ACCD",
    "ACDC",
    "ACDCW",
    "ACER",
    "ACET",
    "ACGL",
    "ACGLN",
    "ACGLO",
    "ACGN",
    "ACHC",
    "ACHL",
    "ACHV",
    "ACIU",
    "ACIW",
    "ACLS",
    "ACLX",
    "ACMR",
    "ACNB",
    "ACNT",
    "ACON",
    "ACONW",
    "ACOR",
    "ACQR",
    "ACQRU",
    "ACQRW",
    "ACRS",
    "ACRV",
    "ACRX",
    "ACST",
    "ACT",
    "ACTG",
    "ACVA",
    "ACXP",
    "ADAG",
    "ADAL",
    "ADALU",
    "ADAP",
    "ADBE",
    "ADD",
    "ADEA",
    "ADER",
    "ADES",
    "ADI",
    "ADIL",
    "ADMA",
    "ADMP",
    "ADN",
    "ADNWW",
    "ADOC",
    "ADOCR",
    "ADOCW",
    "ADP",
    "ADPT",
    "ADSE",
    "ADSEW",
    "ADSK",
    "ADTH",
    "ADTHW",
    "ADTN",
    "ADTX",
    "ADUS",
    "ADV",
    "ADVM",
    "ADVWW",
    "ADXN",
    "AEAE",
    "AEAEU",
    "AEAEW",
    "AEHA",
    "AEHAU",
    "AEHAW",
    "AEHL",
    "AEHR",
    "AEI",
    "AEIS",
    "AEMD",
    "AEP",
    "AEPPZ",
    "AEY",
    "AEYE",
    "AEZS",
    "AFAR",
    "AFARU",
    "AFARW",
    "AFBI",
    "AFCG",
    "AFIB",
    "AFMD",
    "AFRI",
    "AFRIW",
    "AFRM",
    "AFYA",
    "AGAE",
    "AGBA",
    "AGBAW",
    "AGEN",
    "AGFS",
    "AGFY",
    "AGGR",
    "AGGRW",
    "AGIL",
    "AGIO",
    "AGLE",
    "AGMH",
    "AGNC",
    "AGNCL",
    "AGNCM",
    "AGNCN",
    "AGNCO",
    "AGNCP",
    "AGRI",
    "AGRIW",
    "AGRX",
    "AGYS",
    "AHCO",
    "AHG",
    "AHI",
    "AHPI",
    "AHRN",
    "AHRNU",
    "AHRNW",
    "AIB",
    "AIH",
    "AIHS",
    "AIMAU",
    "AIMBU",
    "AIMC",
    "AIMD",
    "AIMDW",
    "AIP",
    "AIRG",
    "AIRS",
    "AIRT",
    "AIRTP",
    "AKAM",
    "AKAN",
    "AKBA",
    "AKLI",
    "AKRO",
    "AKTS",
    "AKTX",
    "AKU",
    "AKYA",
    "ALAR",
    "ALBO",
    "ALBT",
    "ALCO",
    "ALDX",
    "ALEC",
    "ALGM",
    "ALGN",
    "ALGS",
    "ALGT",
    "ALHC",
    "ALIM",
    "ALKS",
    "ALKT",
    "ALLK",
    "ALLO",
    "ALLR",
    "ALLT",
    "ALNY",
    "ALOR",
    "ALORW",
    "ALOT",
    "ALPA",
    "ALPAU",
    "ALPAW",
    "ALPN",
    "ALPP",
    "ALPS",
    "ALR",
    "ALRM",
    "ALRN",
    "ALRS",
    "ALSA",
    "ALSAR",
    "ALSAU",
    "ALSAW",
    "ALT",
    "ALTI",
    "ALTIW",
    "ALTO",
    "ALTR",
    "ALTU",
    "ALTUU",
    "ALTUW",
    "ALVO",
    "ALVOW",
    "ALVR",
    "ALXO",
    "ALYA",
    "ALZN",
    "AMAL",
    "AMAO",
    "AMAOU",
    "AMAOW",
    "AMAT",
    "AMBA",
    "AMCI",
    "AMCIU",
    "AMCIW",
    "AMCX",
    "AMD",
    "AMED",
    "AMEH",
    "AMGN",
    "AMKR",
    "AMLI",
    "AMLX",
    "AMNB",
    "AMOT",
    "AMPG",
    "AMPH",
    "AMPL",
    "AMRK",
    "AMRN",
    "AMRS",
    "AMSC",
    "AMSF",
    "AMST",
    "AMSWA",
    "AMTB",
    "AMTI",
    "AMTX",
    "AMV",
    "AMWD",
    "AMYT",
    "AMZN",
    "ANAB",
    "ANDE",
    "ANEB",
    "ANGH",
    "ANGHW",
    "ANGI",
    "ANGN",
    "ANGO",
    "ANIK",
    "ANIP",
    "ANIX",
    "ANNX",
    "ANPC",
    "ANSS",
    "ANTE",
    "ANTX",
    "ANY",
    "ANZU",
    "ANZUU",
    "ANZUW",
    "AOGO",
    "AOGOW",
    "AOSL",
    "AOUT",
    "APA",
    "APAC",
    "APACW",
    "APCX",
    "APCXW",
    "APDN",
    "APEI",
    "APEN",
    "APGN",
    "APGNW",
    "API",
    "APLD",
    "APLS",
    "APLT",
    "APM",
    "APMI",
    "APMIU",
    "APMIW",
    "APOG",
    "APP",
    "APPF",
    "APPH",
    "APPHW",
    "APPN",
    "APPS",
    "APRE",
    "APTM",
    "APTMU",
    "APTMW",
    "APTO",
    "APTX",
    "APVO",
    "APWC",
    "APXI",
    "APXIU",
    "APXIW",
    "APYX",
    "AQB",
    "AQMS",
    "AQST",
    "AQU",
    "AQUNU",
    "ARAV",
    "ARAY",
    "ARBE",
    "ARBEW",
    "ARBG",
    "ARBGU",
    "ARBGW",
    "ARBK",
    "ARBKL",
    "ARCB",
    "ARCC",
    "ARCE",
    "ARCT",
    "ARDS",
    "ARDX",
    "AREB",
    "AREBW",
    "AREC",
    "ARGX",
    "ARHS",
    "ARIZ",
    "ARIZR",
    "ARIZW",
    "ARKO",
    "ARKOW",
    "ARKR",
    "ARLP",
    "AROW",
    "ARQQ",
    "ARQQW",
    "ARQT",
    "ARRW",
    "ARRWU",
    "ARRWW",
    "ARRY",
    "ARTE",
    "ARTEU",
    "ARTEW",
    "ARTL",
    "ARTNA",
    "ARTW",
    "ARVL",
    "ARVN",
    "ARWR",
    "ARYD",
    "ARYE",
    "ASAP",
    "ASCA",
    "ASCAR",
    "ASCAU",
    "ASCAW",
    "ASCB",
    "ASCBR",
    "ASLE",
    "ASLN",
    "ASMB",
    "ASML",
    "ASND",
    "ASNS",
    "ASO",
    "ASPA",
    "ASPAU",
    "ASPAW",
    "ASPI",
    "ASPS",
    "ASPU",
    "ASRT",
    "ASRV",
    "ASTC",
    "ASTE",
    "ASTI",
    "ASTL",
    "ASTLW",
    "ASTR",
    "ASTS",
    "ASTSW",
    "ASUR",
    "ASYS",
    "ATAI",
    "ATAK",
    "ATAKR",
    "ATAKU",
    "ATAKW",
    "ATAT",
    "ATCOL",
    "ATCX",
    "ATEC",
    "ATER",
    "ATEX",
    "ATHA",
    "ATHE",
    "ATHX",
    "ATIF",
    "ATLC",
    "ATLCL",
    "ATLCP",
    "ATLO",
    "ATLX",
    "ATMC",
    "ATMCR",
    "ATMCU",
    "ATMCW",
    "ATMV",
    "ATMVR",
    "ATMVU",
    "ATNF",
    "ATNFW",
    "ATNI",
    "ATNX",
    "ATOM",
    "ATOS",
    "ATRA",
    "ATRC",
    "ATRI",
    "ATRO",
    "ATSG",
    "ATVI",
    "ATXG",
    "ATXI",
    "ATXS",
    "ATY",
    "AUBN",
    "AUDC",
    "AUGX",
    "AUID",
    "AUPH",
    "AUR",
    "AURA",
    "AURC",
    "AURCW",
    "AUROW",
    "AUTL",
    "AUUD",
    "AUUDW",
    "AUVI",
    "AUVIP",
    "AVAC",
    "AVACW",
    "AVAH",
    "AVAV",
    "AVDL",
    "AVDX",
    "AVGO",
    "AVGR",
    "AVHI",
    "AVID",
    "AVIR",
    "AVNW",
    "AVO",
    "AVPT",
    "AVPTW",
    "AVRO",
    "AVT",
    "AVTA",
    "AVTE",
    "AVTX",
    "AVXL",
    "AWH",
    "AWRE",
    "AXDX",
    "AXGN",
    "AXLA",
    "AXNX",
    "AXON",
    "AXSM",
    "AXTI",
    "AY",
    "AYRO",
    "AYTU",
    "AZ",
    "AZN",
    "AZPN",
    "AZTA",
    "AZYO",
    "BACK",
    "BAER",
    "BAERW",
    "BAFN",
    "BAND",
    "BANF",
    "BANFP",
    "BANR",
    "BANX",
    "BAOS",
    "BASE",
    "BATRA",
    "BATRK",
    "BBBY",
    "BBCP",
    "BBGI",
    "BBIG",
    "BBIO",
    "BBLG",
    "BBLGW",
    "BBSI",
    "BCAB",
    "BCAN",
    "BCBP",
    "BCDA",
    "BCDAW",
    "BCEL",
    "BCLI",
    "BCML",
    "BCOV",
    "BCOW",
    "BCPC",
    "BCRX",
    "BCSA",
    "BCSAU",
    "BCSAW",
    "BCTX",
    "BCTXW",
    "BCYC",
    "BDSX",
    "BDTX",
    "BEAM",
    "BEAT",
    "BEATW",
    "BECN",
    "BEEM",
    "BEEMW",
    "BELFA",
    "BELFB",
    "BFC",
    "BFI",
    "BFIIW",
    "BFIN",
    "BFRI",
    "BFRIW",
    "BFST",
    "BGCP",
    "BGFV",
    "BGNE",
    "BGRY",
    "BGRYW",
    "BGXX",
    "BHAC",
    "BHACU",
    "BHAT",
    "BHF",
    "BHFAL",
    "BHFAM",
    "BHFAN",
    "BHFAO",
    "BHFAP",
    "BIAF",
    "BIAFW",
    "BIDU",
    "BIGC",
    "BIIB",
    "BILI",
    "BIMI",
    "BIOC",
    "BIOL",
    "BIOR",
    "BIOS",
    "BIOSU",
    "BIOSW",
    "BIOT",
    "BIOTW",
    "BIOX",
    "BIRD",
    "BITF",
    "BIVI",
    "BJDX",
    "BJRI",
    "BKCC",
    "BKNG",
    "BKR",
    "BKSC",
    "BKYI",
    "BL",
    "BLBD",
    "BLBX",
    "BLCM",
    "BLDE",
    "BLDEW",
    "BLDP",
    "BLEU",
    "BLEUR",
    "BLEUW",
    "BLFS",
    "BLFY",
    "BLI",
    "BLIN",
    "BLKB",
    "BLMN",
    "BLNG",
    "BLNGU",
    "BLNGW",
    "BLNK",
    "BLNKW",
    "BLPH",
    "BLRX",
    "BLTE",
    "BLU",
    "BLUE",
    "BLZE",
    "BMAQ",
    "BMAQR",
    "BMAQU",
    "BMAQW",
    "BMBL",
    "BMEA",
    "BMRA",
    "BMRC",
    "BMRN",
    "BNGO",
    "BNGOW",
    "BNIX",
    "BNIXR",
    "BNNR",
    "BNOX",
    "BNR",
    "BNRG",
    "BNSO",
    "BNTC",
    "BNTX",
    "BOCN",
    "BOCNW",
    "BOKF",
    "BOLT",
    "BON",
    "BOOM",
    "BOSC",
    "BOTJ",
    "BOXL",
    "BPAC",
    "BPACU",
    "BPACW",
    "BPMC",
    "BPOP",
    "BPOPM",
    "BPRN",
    "BPTH",
    "BPTS",
    "BPYPM",
    "BPYPN",
    "BPYPO",
    "BPYPP",
    "BRAC",
    "BRACR",
    "BRACU",
    "BRAG",
    "BREZ",
    "BREZR",
    "BREZW",
    "BRFH",
    "BRID",
    "BRIV",
    "BRIVU",
    "BRIVW",
    "BRKH",
    "BRKHU",
    "BRKHW",
    "BRKL",
    "BRKR",
    "BRLI",
    "BRLIR",
    "BRLIW",
    "BRLT",
    "BROG",
    "BROGW",
    "BRP",
    "BRQS",
    "BRSH",
    "BRSHW",
    "BRTX",
    "BRY",
    "BRZE",
    "BSBK",
    "BSET",
    "BSFC",
    "BSGA",
    "BSGAR",
    "BSGM",
    "BSQR",
    "BSRR",
    "BSVN",
    "BSY",
    "BTAI",
    "BTB",
    "BTBD",
    "BTBDW",
    "BTBT",
    "BTCS",
    "BTCY",
    "BTMD",
    "BTMDW",
    "BTOG",
    "BTTX",
    "BTWN",
    "BTWNU",
    "BTWNW",
    "BUSE",
    "BVS",
    "BVXV",
    "BWAC",
    "BWACU",
    "BWACW",
    "BWAQ",
    "BWAQR",
    "BWAQU",
    "BWAY",
    "BWB",
    "BWBBP",
    "BWC",
    "BWCAU",
    "BWCAW",
    "BWEN",
    "BWFG",
    "BWMN",
    "BWMX",
    "BWV",
    "BXRX",
    "BYFC",
    "BYND",
    "BYNO",
    "BYRN",
    "BYSI",
    "BYTS",
    "BYTSU",
    "BYTSW",
    "BZ",
    "BZFD",
    "BZFDW",
    "BZUN",
    "CAAS",
    "CABA",
    "CAC",
    "CACC",
    "CACO",
    "CADL",
    "CAKE",
    "CALA",
    "CALB",
    "CALM",
    "CALT",
    "CAMP",
    "CAMT",
    "CAN",
    "CANB",
    "CAPR",
    "CAR",
    "CARA",
    "CARE",
    "CARG",
    "CARV",
    "CASA",
    "CASH",
    "CASI",
    "CASS",
    "CASY",
    "CATC",
    "CATY",
    "CBAN",
    "CBAT",
    "CBAY",
    "CBFV",
    "CBIO",
    "CBNK",
    "CBRG",
    "CBRGU",
    "CBRGW",
    "CBRL",
    "CBSH",
    "CCAI",
    "CCAIU",
    "CCAIW",
    "CCAP",
    "CCB",
    "CCBG",
    "CCCC",
    "CCCS",
    "CCD",
    "CCEP",
    "CCLD",
    "CCLDO",
    "CCLDP",
    "CCLP",
    "CCNE",
    "CCNEP",
    "CCOI",
    "CCRN",
    "CCSI",
    "CCTS",
    "CCTSU",
    "CD",
    "CDAK",
    "CDAQ",
    "CDAQU",
    "CDAQW",
    "CDIO",
    "CDLX",
    "CDMO",
    "CDNA",
    "CDNS",
    "CDRO",
    "CDTX",
    "CDW",
    "CDXC",
    "CDXS",
    "CDZI",
    "CDZIP",
    "CEAD",
    "CEADW",
    "CECO",
    "CEG",
    "CELC",
    "CELH",
    "CELU",
    "CELUW",
    "CELZ",
    "CEMI",
    "CENN",
    "CENQ",
    "CENQU",
    "CENQW",
    "CENT",
    "CENTA",
    "CENX",
    "CERE",
    "CERS",
    "CERT",
    "CETX",
    "CETXP",
    "CEVA",
    "CFB",
    "CFBK",
    "CFFE",
    "CFFEU",
    "CFFEW",
    "CFFI",
    "CFFN",
    "CFFS",
    "CFFSU",
    "CFFSW",
    "CFIV",
    "CFIVW",
    "CFLT",
    "CFMS",
    "CFRX",
    "CFSB",
    "CG",
    "CGABL",
    "CGBD",
    "CGC",
    "CGEM",
    "CGEN",
    "CGNT",
    "CGNX",
    "CGO",
    "CGRN",
    "CGTX",
    "CHCI",
    "CHCO",
    "CHDN",
    "CHEF",
    "CHEK",
    "CHEKZ",
    "CHI",
    "CHK",
    "CHKEL",
    "CHKEW",
    "CHKEZ",
    "CHKP",
    "CHMG",
    "CHNR",
    "CHRD",
    "CHRS",
    "CHRW",
    "CHSCL",
    "CHSCM",
    "CHSCN",
    "CHSCO",
    "CHSCP",
    "CHTR",
    "CHUY",
    "CHW",
    "CHX",
    "CHY",
    "CIDM",
    "CIFR",
    "CIFRW",
    "CIGI",
    "CIH",
    "CIIG",
    "CIIGU",
    "CIIGW",
    "CINC",
    "CINF",
    "CING",
    "CINGW",
    "CISO",
    "CITE",
    "CITEW",
    "CIVB",
    "CIZN",
    "CJJD",
    "CKPT",
    "CLAR",
    "CLAY",
    "CLAYW",
    "CLBK",
    "CLBT",
    "CLBTW",
    "CLDX",
    "CLEU",
    "CLFD",
    "CLGN",
    "CLIN",
    "CLINR",
    "CLINU",
    "CLINW",
    "CLIR",
    "CLLS",
    "CLMB",
    "CLMT",
    "CLNE",
    "CLNN",
    "CLNNW",
    "CLOE",
    "CLOER",
    "CLOV",
    "CLPS",
    "CLPT",
    "CLRB",
    "CLRC",
    "CLRCR",
    "CLRCW",
    "CLRO",
    "CLSD",
    "CLSK",
    "CLST",
    "CLVR",
    "CLVRW",
    "CLWT",
    "CLXT",
    "CMAX",
    "CMAXW",
    "CMBM",
    "CMCA",
    "CMCAU",
    "CMCAW",
    "CMCO",
    "CMCSA",
    "CMCT",
    "CME",
    "CMLS",
    "CMMB",
    "CMND",
    "CMPO",
    "CMPOW",
    "CMPR",
    "CMPS",
    "CMPX",
    "CMRA",
    "CMRAW",
    "CMRX",
    "CMTL",
    "CNCE",
    "CNDT",
    "CNET",
    "CNEY",
    "CNFR",
    "CNFRL",
    "CNGL",
    "CNGLW",
    "CNNB",
    "CNOB",
    "CNOBP",
    "CNSL",
    "CNSP",
    "CNTA",
    "CNTB",
    "CNTG",
    "CNTX",
    "CNTY",
    "CNXA",
    "CNXC",
    "CNXN",
    "COCO",
    "COCP",
    "CODA",
    "CODX",
    "COEP",
    "COEPW",
    "COFS",
    "COGT",
    "COHR",
    "COHU",
    "COIN",
    "COKE",
    "COLB",
    "COLL",
    "COLM",
    "COMM",
    "COMS",
    "COMSP",
    "COMSW",
    "CONN",
    "CONX",
    "CONXU",
    "CONXW",
    "COOL",
    "COOLU",
    "COOLW",
    "COOP",
    "CORT",
    "COSM",
    "COST",
    "COUP",
    "COWN",
    "COWNL",
    "COYA",
    "CPAA",
    "CPAAU",
    "CPAAW",
    "CPAQ",
    "CPAR",
    "CPARU",
    "CPARW",
    "CPHC",
    "CPIX",
    "CPLP",
    "CPOP",
    "CPRT",
    "CPRX",
    "CPSH",
    "CPSI",
    "CPSS",
    "CPTN",
    "CPTNW",
    "CPZ",
    "CRAI",
    "CRBP",
    "CRBU",
    "CRCT",
    "CRDF",
    "CRDL",
    "CRDO",
    "CREC",
    "CRECW",
    "CREG",
    "CRESW",
    "CRESY",
    "CREX",
    "CRGE",
    "CRGO",
    "CRIS",
    "CRKN",
    "CRMD",
    "CRMT",
    "CRNC",
    "CRNT",
    "CRNX",
    "CRON",
    "CROX",
    "CRSP",
    "CRSR",
    "CRTO",
    "CRUS",
    "CRVL",
    "CRVS",
    "CRWD",
    "CRWS",
    "CRZN",
    "CRZNW",
    "CSBR",
    "CSCO",
    "CSGP",
    "CSGS",
    "CSII",
    "CSIQ",
    "CSLM",
    "CSLMW",
    "CSPI",
    "CSQ",
    "CSSE",
    "CSSEL",
    "CSSEN",
    "CSSEP",
    "CSTE",
    "CSTL",
    "CSTR",
    "CSWC",
    "CSWI",
    "CSX",
    "CTAQ",
    "CTAQU",
    "CTAQW",
    "CTAS",
    "CTBI",
    "CTG",
    "CTHR",
    "CTIB",
    "CTIC",
    "CTKB",
    "CTLP",
    "CTMX",
    "CTRM",
    "CTRN",
    "CTSH",
    "CTSO",
    "CTXR",
    "CUBA",
    "CUE",
    "CUEN",
    "CUENW",
    "CULL",
    "CURI",
    "CURIW",
    "CUTR",
    "CVAC",
    "CVBF",
    "CVCO",
    "CVCY",
    "CVGI",
    "CVGW",
    "CVKD",
    "CVLG",
    "CVLT",
    "CVLY",
    "CVRX",
    "CVT",
    "CVV",
    "CWBC",
    "CWBR",
    "CWCO",
    "CWST",
    "CXDO",
    "CYAD",
    "CYAN",
    "CYBR",
    "CYCC",
    "CYCCP",
    "CYCN",
    "CYN",
    "CYRN",
    "CYRX",
    "CYT",
    "CYTH",
    "CYTHW",
    "CYTK",
    "CYTO",
    "CYXT",
    "CZFS",
    "CZNC",
    "CZR",
    "CZWI",
    "DADA",
    "DAIO",
    "DAKT",
    "DALN",
    "DALS",
    "DARE",
    "DATS",
    "DATSW",
    "DAVE",
    "DAVEW",
    "DAWN",
    "DBGI",
    "DBGIW",
    "DBTX",
    "DBVT",
    "DBX",
    "DCBO",
    "DCFC",
    "DCFCW",
    "DCGO",
    "DCOM",
    "DCOMP",
    "DCPH",
    "DCRD",
    "DCRDU",
    "DCRDW",
    "DCT",
    "DCTH",
    "DDI",
    "DDOG",
    "DECA",
    "DECAU",
    "DECAW",
    "DENN",
    "DERM",
    "DFFN",
    "DFLI",
    "DFLIW",
    "DGHI",
    "DGICA",
    "DGICB",
    "DGII",
    "DGLY",
    "DGNU",
    "DH",
    "DHAC",
    "DHACW",
    "DHC",
    "DHCA",
    "DHCAU",
    "DHCAW",
    "DHCNI",
    "DHCNL",
    "DHHC",
    "DHHCU",
    "DHHCW",
    "DHIL",
    "DIBS",
    "DICE",
    "DIOD",
    "DISA",
    "DISAU",
    "DISH",
    "DJCO",
    "DKDCA",
    "DKDCU",
    "DKDCW",
    "DKNG",
    "DLHC",
    "DLO",
    "DLPN",
    "DLTH",
    "DLTR",
    "DMAC",
    "DMAQ",
    "DMAQR",
    "DMLP",
    "DMRC",
    "DMTK",
    "DNAB",
    "DNAD",
    "DNLI",
    "DNUT",
    "DOCU",
    "DOGZ",
    "DOMH",
    "DOMO",
    "DOOO",
    "DORM",
    "DOX",
    "DOYU",
    "DPCS",
    "DPCSU",
    "DPCSW",
    "DPRO",
    "DRCT",
    "DRCTW",
    "DRIO",
    "DRMA",
    "DRMAW",
    "DRRX",
    "DRS",
    "DRTS",
    "DRTSW",
    "DRTT",
    "DRUG",
    "DRVN",
    "DSEY",
    "DSGN",
    "DSGR",
    "DSGX",
    "DSKE",
    "DSP",
    "DSWL",
    "DTEA",
    "DTIL",
    "DTOC",
    "DTOCU",
    "DTOCW",
    "DTRT",
    "DTRTU",
    "DTRTW",
    "DTSS",
    "DTST",
    "DTSTW",
    "DUET",
    "DUETU",
    "DUETW",
    "DUNE",
    "DUNEU",
    "DUNEW",
    "DUO",
    "DUOL",
    "DUOT",
    "DVAX",
    "DWAC",
    "DWACU",
    "DWACW",
    "DWSN",
    "DXCM",
    "DXLG",
    "DXPE",
    "DXR",
    "DXYN",
    "DYAI",
    "DYN",
    "DYNT",
    "DZSI",
    "EA",
    "EAC",
    "EACPW",
    "EAR",
    "EAST",
    "EBAC",
    "EBACU",
    "EBACW",
    "EBAY",
    "EBC",
    "EBET",
    "EBIX",
    "EBMT",
    "EBON",
    "EBTC",
    "ECBK",
    "ECOR",
    "ECPG",
    "ECX",
    "ECXWW",
    "EDAP",
    "EDBL",
    "EDBLW",
    "EDIT",
    "EDRY",
    "EDSA",
    "EDTK",
    "EDTX",
    "EDUC",
    "EEFT",
    "EEIQ",
    "EFHT",
    "EFHTR",
    "EFHTW",
    "EFOI",
    "EFSC",
    "EFSCP",
    "EFTR",
    "EFTRW",
    "EGAN",
    "EGBN",
    "EGHT",
    "EGIO",
    "EGLX",
    "EGRX",
    "EH",
    "EHTH",
    "EIGR",
    "EJH",
    "EKSO",
    "ELBM",
    "ELDN",
    "ELEV",
    "ELOX",
    "ELSE",
    "ELTK",
    "ELYM",
    "ELYS",
    "EM",
    "EMBC",
    "EMBK",
    "EMBKW",
    "EMCG",
    "EMCGR",
    "EMCGW",
    "EMKR",
    "EML",
    "EMLD",
    "EMLDU",
    "EMLDW",
    "ENCP",
    "ENCPW",
    "ENER",
    "ENERR",
    "ENERW",
    "ENG",
    "ENLV",
    "ENOB",
    "ENPH",
    "ENSC",
    "ENSG",
    "ENTA",
    "ENTF",
    "ENTFU",
    "ENTFW",
    "ENTG",
    "ENTX",
    "ENTXW",
    "ENVB",
    "ENVX",
    "EOLS",
    "EOSE",
    "EOSEW",
    "EPIX",
    "EPOW",
    "EPSN",
    "EQ",
    "EQBK",
    "EQIX",
    "EQRX",
    "EQRXW",
    "ERAS",
    "ERES",
    "ERESW",
    "ERIC",
    "ERIE",
    "ERII",
    "ERNA",
    "ERYP",
    "ESAC",
    "ESACU",
    "ESACW",
    "ESCA",
    "ESEA",
    "ESGR",
    "ESGRO",
    "ESGRP",
    "ESLT",
    "ESOA",
    "ESPR",
    "ESQ",
    "ESSA",
    "ESTA",
    "ETNB",
    "ETON",
    "ETSY",
    "EUCR",
    "EUCRU",
    "EUCRW",
    "EUDA",
    "EUDAW",
    "EVAX",
    "EVBG",
    "EVCM",
    "EVER",
    "EVGN",
    "EVGO",
    "EVGOW",
    "EVGR",
    "EVGRU",
    "EVGRW",
    "EVLO",
    "EVLV",
    "EVLVW",
    "EVO",
    "EVOJ",
    "EVOJW",
    "EVOK",
    "EVOP",
    "EVRG",
    "EVTV",
    "EWBC",
    "EWCZ",
    "EWTX",
    "EXAI",
    "EXAS",
    "EXC",
    "EXEL",
    "EXFY",
    "EXLS",
    "EXPD",
    "EXPE",
    "EXPI",
    "EXPO",
    "EXTR",
    "EYE",
    "EYEN",
    "EYPT",
    "EZFL",
    "EZGO",
    "EZPW",
    "FA",
    "FAMI",
    "FANG",
    "FANH",
    "FARM",
    "FARO",
    "FAST",
    "FAT",
    "FATBB",
    "FATBP",
    "FATBW",
    "FATE",
    "FATP",
    "FATPU",
    "FATPW",
    "FAZE",
    "FAZEW",
    "FBIO",
    "FBIOP",
    "FBIZ",
    "FBMS",
    "FBNC",
    "FBRX",
    "FCAP",
    "FCBC",
    "FCCO",
    "FCEL",
    "FCFS",
    "FCNCA",
    "FCNCO",
    "FCNCP",
    "FCRD",
    "FCUV",
    "FDBC",
    "FDMT",
    "FDUS",
    "FEAM",
    "FEIM",
    "FELE",
    "FEMY",
    "FENC",
    "FEXD",
    "FEXDR",
    "FEXDU",
    "FEXDW",
    "FFBC",
    "FFBW",
    "FFIC",
    "FFIE",
    "FFIEW",
    "FFIN",
    "FFIV",
    "FFNW",
    "FFWM",
    "FGBI",
    "FGBIP",
    "FGEN",
    "FGF",
    "FGFPP",
    "FGI",
    "FGMC",
    "FGMCW",
    "FHB",
    "FHLT",
    "FHLTU",
    "FHLTW",
    "FHTX",
    "FIAC",
    "FIACU",
    "FIBK",
    "FICV",
    "FICVU",
    "FICVW",
    "FINW",
    "FIP",
    "FISI",
    "FISV",
    "FITB",
    "FITBI",
    "FITBO",
    "FITBP",
    "FIVE",
    "FIVN",
    "FIXX",
    "FIZZ",
    "FKWL",
    "FLEX",
    "FLFV",
    "FLFVR",
    "FLFVW",
    "FLGC",
    "FLGT",
    "FLIC",
    "FLJ",
    "FLL",
    "FLNC",
    "FLNT",
    "FLUX",
    "FLWS",
    "FLXS",
    "FLYW",
    "FMAO",
    "FMBH",
    "FMIV",
    "FMIVW",
    "FMNB",
    "FNCB",
    "FNCH",
    "FNGR",
    "FNKO",
    "FNLC",
    "FNVT",
    "FNVTU",
    "FNVTW",
    "FNWB",
    "FNWD",
    "FOCS",
    "FOLD",
    "FONR",
    "FORA",
    "FORD",
    "FORM",
    "FORR",
    "FORTY",
    "FOSL",
    "FOSLL",
    "FOX",
    "FOXA",
    "FOXF",
    "FOXW",
    "FOXWU",
    "FOXWW",
    "FPAY",
    "FRAF",
    "FRBA",
    "FRBK",
    "FRBN",
    "FRBNU",
    "FRBNW",
    "FREE",
    "FREEW",
    "FREQ",
    "FRG",
    "FRGAP",
    "FRGI",
    "FRGT",
    "FRHC",
    "FRLA",
    "FRLAU",
    "FRLN",
    "FRME",
    "FRMEP",
    "FROG",
    "FRON",
    "FRONU",
    "FRONW",
    "FRPH",
    "FRPT",
    "FRSG",
    "FRSGU",
    "FRSGW",
    "FRSH",
    "FRST",
    "FRSX",
    "FRTX",
    "FRZA",
    "FSBC",
    "FSBW",
    "FSEA",
    "FSFG",
    "FSLR",
    "FSRX",
    "FSRXU",
    "FSRXW",
    "FSTR",
    "FSTX",
    "FSV",
    "FTAA",
    "FTAAW",
    "FTAI",
    "FTAIN",
    "FTAIO",
    "FTAIP",
    "FTCI",
    "FTDR",
    "FTEK",
    "FTFT",
    "FTHM",
    "FTII",
    "FTIIU",
    "FTIIW",
    "FTNT",
    "FTPA",
    "FTPAW",
    "FULC",
    "FULT",
    "FULTP",
    "FUNC",
    "FUND",
    "FUSB",
    "FUSN",
    "FUTU",
    "FUV",
    "FVCB",
    "FWAC",
    "FWBI",
    "FWONA",
    "FWONK",
    "FWRD",
    "FWRG",
    "FXCO",
    "FXCOR",
    "FXCOW",
    "FXNC",
    "FYBR",
    "GABC",
    "GAIA",
    "GAIN",
    "GAINN",
    "GAINZ",
    "GALT",
    "GAMB",
    "GAMC",
    "GAMCU",
    "GAMCW",
    "GAME",
    "GAN",
    "GANX",
    "GASS",
    "GATE",
    "GATEU",
    "GATEW",
    "GBBK",
    "GBBKR",
    "GBBKW",
    "GBDC",
    "GBIO",
    "GBNH",
    "GBNY",
    "GBRG",
    "GBRGR",
    "GCBC",
    "GCMG",
    "GCMGW",
    "GCT",
    "GCTK",
    "GDC",
    "GDEN",
    "GDNR",
    "GDNRU",
    "GDRX",
    "GDS",
    "GDST",
    "GDSTR",
    "GDSTU",
    "GDYN",
    "GECC",
    "GECCM",
    "GECCN",
    "GECCO",
    "GEEX",
    "GEEXU",
    "GEEXW",
    "GEG",
    "GEGGL",
    "GEHC",
    "GEN",
    "GENE",
    "GENQ",
    "GENQU",
    "GEOS",
    "GERN",
    "GET",
    "GEVO",
    "GFAI",
    "GFAIW",
    "GFGD",
    "GFGDR",
    "GFGDU",
    "GFGDW",
    "GFS",
    "GGAA",
    "GGAL",
    "GGE",
    "GGR",
    "GGROW",
    "GH",
    "GHIX",
    "GHIXU",
    "GHIXW",
    "GHRS",
    "GHSI",
    "GIFI",
    "GIGM",
    "GIII",
    "GILD",
    "GILT",
    "GIPR",
    "GIPRW",
    "GLAD",
    "GLBE",
    "GLBS",
    "GLBZ",
    "GLDD",
    "GLG",
    "GLLI",
    "GLLIU",
    "GLLIW",
    "GLMD",
    "GLNG",
    "GLPG",
    "GLPI",
    "GLRE",
    "GLSI",
    "GLST",
    "GLSTR",
    "GLSTU",
    "GLSTW",
    "GLTO",
    "GLUE",
    "GLYC",
    "GMAB",
    "GMBL",
    "GMBLP",
    "GMBLW",
    "GMBLZ",
    "GMDA",
    "GMFI",
    "GMFIW",
    "GMGI",
    "GMVD",
    "GMVDW",
    "GNFT",
    "GNLN",
    "GNLX",
    "GNPX",
    "GNSS",
    "GNTA",
    "GNTX",
    "GNTY",
    "GNUS",
    "GO",
    "GOCO",
    "GOEV",
    "GOEVW",
    "GOGL",
    "GOGO",
    "GOOD",
    "GOODN",
    "GOODO",
    "GOOG",
    "GOOGL",
    "GOSS",
    "GOVX",
    "GOVXW",
    "GP",
    "GPAC",
    "GPACU",
    "GPACW",
    "GPP",
    "GPRE",
    "GPRO",
    "GRAB",
    "GRABW",
    "GRAY",
    "GRCL",
    "GRCY",
    "GRCYU",
    "GRCYW",
    "GREE",
    "GREEL",
    "GRFS",
    "GRIL",
    "GRIN",
    "GRNA",
    "GRNAW",
    "GRNQ",
    "GROM",
    "GROMW",
    "GROW",
    "GRPH",
    "GRPN",
    "GRRR",
    "GRRRW",
    "GRTS",
    "GRTX",
    "GRVY",
    "GRWG",
    "GSBC",
    "GSD",
    "GSDWW",
    "GSHD",
    "GSIT",
    "GSM",
    "GSMG",
    "GSMGW",
    "GSRM",
    "GSRMR",
    "GSRMU",
    "GSRMW",
    "GSUN",
    "GT",
    "GTAC",
    "GTACU",
    "GTBP",
    "GTEC",
    "GTH",
    "GTHX",
    "GTIM",
    "GTLB",
    "GTX",
    "GTXAP",
    "GURE",
    "GVCI",
    "GVCIW",
    "GVP",
    "GWAV",
    "GWII",
    "GWIIW",
    "GWRS",
    "GXII",
    "GXIIW",
    "GYRO",
    "HA",
    "HAFC",
    "HAIA",
    "HAIAW",
    "HAIN",
    "HALL",
    "HALO",
    "HAPP",
    "HARP",
    "HAS",
    "HAYN",
    "HBAN",
    "HBANM",
    "HBANP",
    "HBCP",
    "HBIO",
    "HBNC",
    "HBT",
    "HCAT",
    "HCCI",
    "HCDI",
    "HCDIP",
    "HCDIW",
    "HCDIZ",
    "HCKT",
    "HCM",
    "HCMA",
    "HCMAW",
    "HCNE",
    "HCNEU",
    "HCP",
    "HCSG",
    "HCTI",
    "HCVI",
    "HCVIU",
    "HCVIW",
    "HCWB",
    "HDSN",
    "HEAR",
    "HEES",
    "HELE",
    "HEPA",
    "HEPS",
    "HERA",
    "HERAW",
    "HEXO",
    "HFBL",
    "HFFG",
    "HFWA",
    "HGBL",
    "HGEN",
    "HHGC",
    "HHGCR",
    "HHGCU",
    "HHGCW",
    "HHS",
    "HIBB",
    "HIFS",
    "HIHO",
    "HILS",
    "HIMX",
    "HITI",
    "HIVE",
    "HLBZ",
    "HLBZW",
    "HLIT",
    "HLMN",
    "HLNE",
    "HLTH",
    "HLVX",
    "HMAC",
    "HMACU",
    "HMNF",
    "HMPT",
    "HMST",
    "HNNA",
    "HNNAZ",
    "HNRG",
    "HNST",
    "HNVR",
    "HOFT",
    "HOFV",
    "HOFVW",
    "HOLI",
    "HOLO",
    "HOLOW",
    "HOLX",
    "HON",
    "HONE",
    "HOOD",
    "HOOK",
    "HOPE",
    "HORI",
    "HORIW",
    "HOTH",
    "HOUR",
    "HOVNP",
    "HOWL",
    "HPCO",
    "HPK",
    "HPKEW",
    "HPLT",
    "HPLTU",
    "HPLTW",
    "HQI",
    "HQY",
    "HRMY",
    "HROW",
    "HROWL",
    "HROWM",
    "HRTX",
    "HRZN",
    "HSAQ",
    "HSCS",
    "HSCSW",
    "HSDT",
    "HSIC",
    "HSII",
    "HSKA",
    "HSON",
    "HSPO",
    "HSPOR",
    "HSPOU",
    "HSPOW",
    "HST",
    "HSTM",
    "HSTO",
    "HTBI",
    "HTBK",
    "HTCR",
    "HTGM",
    "HTHT",
    "HTIA",
    "HTIBP",
    "HTLD",
    "HTLF",
    "HTLFP",
    "HTOO",
    "HTOOW",
    "HTZ",
    "HTZWW",
    "HUBG",
    "HUDA",
    "HUDAR",
    "HUDAU",
    "HUDI",
    "HUGE",
    "HUIZ",
    "HUMA",
    "HUMAW",
    "HURC",
    "HURN",
    "HUT",
    "HVBC",
    "HWBK",
    "HWC",
    "HWCPZ",
    "HWEL",
    "HWELU",
    "HWELW",
    "HWKN",
    "HYFM",
    "HYMC",
    "HYMCL",
    "HYMCW",
    "HYPR",
    "HYRE",
    "HYW",
    "HYZN",
    "HYZNW",
    "HZNP",
    "IAC",
    "IART",
    "IAS",
    "IBCP",
    "IBEX",
    "IBKR",
    "IBOC",
    "IBRX",
    "IBTX",
    "ICAD",
    "ICCC",
    "ICCH",
    "ICCM",
    "ICFI",
    "ICHR",
    "ICLK",
    "ICLR",
    "ICMB",
    "ICPT",
    "ICU",
    "ICUCW",
    "ICUI",
    "ICVX",
    "IDAI",
    "IDBA",
    "IDCC",
    "IDEX",
    "IDN",
    "IDXX",
    "IDYA",
    "IEP",
    "IESC",
    "IFBD",
    "IFRX",
    "IGIC",
    "IGICW",
    "IGMS",
    "IGTA",
    "IGTAR",
    "IHRT",
    "III",
    "IIIV",
    "IINN",
    "IINNW",
    "IIVIP",
    "IKNA",
    "IKT",
    "ILAG",
    "ILMN",
    "ILPT",
    "IMAB",
    "IMACW",
    "IMAQ",
    "IMAQR",
    "IMAQU",
    "IMAQW",
    "IMBI",
    "IMBIL",
    "IMCC",
    "IMCI",
    "IMCR",
    "IMGN",
    "IMKTA",
    "IMMP",
    "IMMR",
    "IMMX",
    "IMNM",
    "IMNN",
    "IMOS",
    "IMPL",
    "IMPP",
    "IMPPP",
    "IMRA",
    "IMRN",
    "IMRX",
    "IMTE",
    "IMTX",
    "IMTXW",
    "IMUX",
    "IMV",
    "IMVT",
    "IMXI",
    "INAB",
    "INBK",
    "INBKZ",
    "INBS",
    "INBX",
    "INCR",
    "INCY",
    "INDB",
    "INDI",
    "INDIW",
    "INDP",
    "INDT",
    "INFI",
    "INFN",
    "INGN",
    "INKA",
    "INKAU",
    "INKT",
    "INM",
    "INMB",
    "INMD",
    "INNV",
    "INO",
    "INOD",
    "INPX",
    "INSE",
    "INSG",
    "INSM",
    "INTA",
    "INTC",
    "INTE",
    "INTG",
    "INTR",
    "INTU",
    "INTZ",
    "INVA",
    "INVE",
    "INVO",
    "INVZ",
    "INVZW",
    "INZY",
    "IOAC",
    "IOACW",
    "IOBT",
    "IONM",
    "IONR",
    "IONS",
    "IOSP",
    "IOVA",
    "IPA",
    "IPAR",
    "IPAX",
    "IPAXU",
    "IPAXW",
    "IPDN",
    "IPGP",
    "IPHA",
    "IPSC",
    "IPVI",
    "IPVIU",
    "IPW",
    "IPWR",
    "IPX",
    "IQ",
    "IQMD",
    "IQMDU",
    "IQMDW",
    "IRAA",
    "IRAAU",
    "IRBT",
    "IRDM",
    "IREN",
    "IRIX",
    "IRMD",
    "IRON",
    "IROQ",
    "IRTC",
    "IRWD",
    "ISEE",
    "ISIG",
    "ISO",
    "ISPC",
    "ISPO",
    "ISPOW",
    "ISRG",
    "ISRLU",
    "ISSC",
    "ISTR",
    "ISUN",
    "ITAQ",
    "ITAQU",
    "ITAQW",
    "ITCI",
    "ITI",
    "ITIC",
    "ITOS",
    "ITQ",
    "ITQRU",
    "ITRI",
    "ITRM",
    "ITRN",
    "IVA",
    "IVAC",
    "IVCA",
    "IVCAU",
    "IVCAW",
    "IVCB",
    "IVCBU",
    "IVCBW",
    "IVCP",
    "IVCPW",
    "IVDA",
    "IVDAW",
    "IVVD",
    "IXAQ",
    "IXAQU",
    "IXHL",
    "IZEA",
    "JACK",
    "JAGX",
    "JAKK",
    "JAMF",
    "JAN",
    "JANX",
    "JAQC",
    "JAQCU",
    "JAZZ",
    "JBHT",
    "JBLU",
    "JBSS",
    "JCSE",
    "JCTCF",
    "JD",
    "JEWL",
    "JFBR",
    "JFBRW",
    "JFIN",
    "JFU",
    "JG",
    "JGGC",
    "JGGCR",
    "JGGCU",
    "JGGCW",
    "JJSF",
    "JKHY",
    "JMAC",
    "JMACW",
    "JMSB",
    "JNCE",
    "JOAN",
    "JOUT",
    "JRSH",
    "JRVR",
    "JSM",
    "JSPR",
    "JSPRW",
    "JUGG",
    "JUGGU",
    "JUGGW",
    "JUPW",
    "JUPWW",
    "JVA",
    "JWAC",
    "JWACR",
    "JWEL",
    "JXJT",
    "JYNT",
    "JZ",
    "JZXN",
    "KA",
    "KACL",
    "KACLR",
    "KAII",
    "KAIIU",
    "KAIIW",
    "KAL",
    "KALA",
    "KALU",
    "KALV",
    "KALWW",
    "KARO",
    "KAVL",
    "KBAL",
    "KBNT",
    "KBNTW",
    "KC",
    "KDNY",
    "KDP",
    "KE",
    "KELYA",
    "KELYB",
    "KEQU",
    "KERN",
    "KERNW",
    "KFFB",
    "KFRC",
    "KHC",
    "KIDS",
    "KINS",
    "KINZ",
    "KINZU",
    "KINZW",
    "KIRK",
    "KITT",
    "KITTW",
    "KLAC",
    "KLIC",
    "KLTR",
    "KLXE",
    "KMDA",
    "KMPH",
    "KNBE",
    "KNDI",
    "KNSA",
    "KNTE",
    "KOD",
    "KOPN",
    "KOSS",
    "KPLT",
    "KPLTW",
    "KPRX",
    "KPTI",
    "KRBP",
    "KRKR",
    "KRMD",
    "KRNL",
    "KRNLU",
    "KRNLW",
    "KRNT",
    "KRNY",
    "KRON",
    "KROS",
    "KRT",
    "KRTX",
    "KRUS",
    "KRYS",
    "KSCP",
    "KSI",
    "KSICU",
    "KSICW",
    "KSPN",
    "KTCC",
    "KTOS",
    "KTRA",
    "KTTA",
    "KTTAW",
    "KURA",
    "KVHI",
    "KVSA",
    "KVSC",
    "KWE",
    "KWESW",
    "KXIN",
    "KYCH",
    "KYCHR",
    "KYCHW",
    "KYMR",
    "KZIA",
    "KZR",
    "LAB",
    "LABP",
    "LAKE",
    "LAMR",
    "LANC",
    "LAND",
    "LANDM",
    "LANDO",
    "LARK",
    "LASE",
    "LASR",
    "LATG",
    "LATGU",
    "LATGW",
    "LAUR",
    "LAZR",
    "LAZY",
    "LBAI",
    "LBBB",
    "LBBBR",
    "LBBBU",
    "LBBBW",
    "LBC",
    "LBPH",
    "LBRDA",
    "LBRDK",
    "LBRDP",
    "LBTYA",
    "LBTYB",
    "LBTYK",
    "LCA",
    "LCAA",
    "LCAAU",
    "LCAAW",
    "LCAHU",
    "LCAHW",
    "LCFY",
    "LCFYW",
    "LCID",
    "LCNB",
    "LCUT",
    "LDHA",
    "LDHAU",
    "LDHAW",
    "LE",
    "LECO",
    "LEDS",
    "LEE",
    "LEGA",
    "LEGAU",
    "LEGAW",
    "LEGH",
    "LEGN",
    "LESL",
    "LEXX",
    "LEXXW",
    "LFAC",
    "LFACW",
    "LFCR",
    "LFLY",
    "LFLYW",
    "LFMD",
    "LFMDP",
    "LFST",
    "LFUS",
    "LFVN",
    "LGAC",
    "LGACU",
    "LGACW",
    "LGHL",
    "LGHLW",
    "LGIH",
    "LGMK",
    "LGND",
    "LGO",
    "LGST",
    "LGSTU",
    "LGSTW",
    "LGTO",
    "LGTOU",
    "LGTOW",
    "LGVC",
    "LGVCU",
    "LGVCW",
    "LGVN",
    "LHCG",
    "LHDX",
    "LI",
    "LIAN",
    "LIBY",
    "LIBYW",
    "LIDR",
    "LIDRW",
    "LIFE",
    "LIFW",
    "LIFWW",
    "LIFWZ",
    "LILA",
    "LILAK",
    "LILM",
    "LILMW",
    "LINC",
    "LIND",
    "LINK",
    "LION",
    "LIONU",
    "LIONW",
    "LIPO",
    "LIQT",
    "LITE",
    "LITM",
    "LITT",
    "LITTU",
    "LITTW",
    "LIVB",
    "LIVBW",
    "LIVE",
    "LIVN",
    "LIXT",
    "LIXTW",
    "LIZI",
    "LKCO",
    "LKFN",
    "LKQ",
    "LMAT",
    "LMB",
    "LMDX",
    "LMDXW",
    "LMFA",
    "LMNL",
    "LMNR",
    "LMST",
    "LNKB",
    "LNSR",
    "LNT",
    "LNTH",
    "LNW",
    "LOAN",
    "LOCO",
    "LOGI",
    "LOOP",
    "LOPE",
    "LOV",
    "LOVE",
    "LPCN",
    "LPLA",
    "LPRO",
    "LPSN",
    "LPTH",
    "LPTX",
    "LQDA",
    "LQDT",
    "LRCX",
    "LRFC",
    "LRMR",
    "LSAK",
    "LSBK",
    "LSCC",
    "LSEA",
    "LSEAW",
    "LSTA",
    "LSTR",
    "LSXMA",
    "LSXMB",
    "LSXMK",
    "LTBR",
    "LTCH",
    "LTCHW",
    "LTRN",
    "LTRPA",
    "LTRPB",
    "LTRX",
    "LTRY",
    "LTRYW",
    "LUCD",
    "LUCY",
    "LUCYW",
    "LULU",
    "LUMO",
    "LUNA",
    "LUNG",
    "LUXH",
    "LVAC",
    "LVACU",
    "LVACW",
    "LVLU",
    "LVO",
    "LVOX",
    "LVOXU",
    "LVOXW",
    "LVRA",
    "LVTX",
    "LWAY",
    "LWLG",
    "LX",
    "LXEH",
    "LXRX",
    "LYEL",
    "LYFT",
    "LYLT",
    "LYRA",
    "LYT",
    "LYTS",
    "LZ",
    "MACA",
    "MACAW",
    "MACK",
    "MANH",
    "MAPS",
    "MAPSW",
    "MAQC",
    "MAQCW",
    "MAR",
    "MARA",
    "MARK",
    "MARPS",
    "MASI",
    "MASS",
    "MAT",
    "MATH",
    "MATW",
    "MAXN",
    "MAYS",
    "MBCN",
    "MBIN",
    "MBINM",
    "MBINN",
    "MBINO",
    "MBINP",
    "MBIO",
    "MBLY",
    "MBNKP",
    "MBOT",
    "MBRX",
    "MBTC",
    "MBTCR",
    "MBUU",
    "MBWM",
    "MCAA",
    "MCAAW",
    "MCAC",
    "MCACW",
    "MCAE",
    "MCAER",
    "MCAF",
    "MCAFR",
    "MCAFU",
    "MCAG",
    "MCAGU",
    "MCBC",
    "MCBS",
    "MCFT",
    "MCHP",
    "MCHX",
    "MCLD",
    "MCLDW",
    "MCRB",
    "MCRI",
    "MCVT",
    "MDB",
    "MDGL",
    "MDGS",
    "MDGSW",
    "MDIA",
    "MDJH",
    "MDLZ",
    "MDNA",
    "MDRR",
    "MDRRP",
    "MDRX",
    "MDVL",
    "MDWD",
    "MDWT",
    "MDXG",
    "MDXH",
    "ME",
    "MEAC",
    "MEACW",
    "MEDP",
    "MEDS",
    "MEGL",
    "MEIP",
    "MEKA",
    "MELI",
    "MEOA",
    "MEOAW",
    "MEOH",
    "MERC",
    "MESA",
    "MESO",
    "META",
    "METC",
    "METCL",
    "METX",
    "METXW",
    "MF",
    "MFH",
    "MFIC",
    "MFIN",
    "MGAM",
    "MGEE",
    "MGI",
    "MGIC",
    "MGNI",
    "MGNX",
    "MGOL",
    "MGPI",
    "MGRC",
    "MGTA",
    "MGTX",
    "MGYR",
    "MHLD",
    "MHUA",
    "MICS",
    "MICT",
    "MIDD",
    "MIGI",
    "MIND",
    "MINDP",
    "MINM",
    "MIRM",
    "MIRO",
    "MIST",
    "MITA",
    "MITAU",
    "MITAW",
    "MITK",
    "MKSI",
    "MKTW",
    "MKTX",
    "MKUL",
    "MLAB",
    "MLAC",
    "MLACU",
    "MLACW",
    "MLAI",
    "MLAIU",
    "MLAIW",
    "MLCO",
    "MLEC",
    "MLECW",
    "MLGO",
    "MLKN",
    "MLTX",
    "MLVF",
    "MMAT",
    "MMLP",
    "MMMB",
    "MMSI",
    "MMV",
    "MMVWW",
    "MMYT",
    "MNDO",
    "MNDY",
    "MNKD",
    "MNMD",
    "MNOV",
    "MNPR",
    "MNRO",
    "MNSB",
    "MNSBP",
    "MNST",
    "MNTK",
    "MNTS",
    "MNTSW",
    "MNTV",
    "MNTX",
    "MOB",
    "MOBBW",
    "MOBQ",
    "MOBV",
    "MODD",
    "MODV",
    "MOFG",
    "MOGO",
    "MOLN",
    "MOMO",
    "MOND",
    "MOR",
    "MORF",
    "MORN",
    "MOTS",
    "MOVE",
    "MOXC",
    "MPAA",
    "MPB",
    "MPRA",
    "MPRAU",
    "MPRAW",
    "MPWR",
    "MQ",
    "MRAI",
    "MRAM",
    "MRBK",
    "MRCC",
    "MRCY",
    "MREO",
    "MRIN",
    "MRKR",
    "MRM",
    "MRNA",
    "MRNS",
    "MRSN",
    "MRTN",
    "MRTX",
    "MRUS",
    "MRVI",
    "MRVL",
    "MSAC",
    "MSACW",
    "MSBI",
    "MSBIP",
    "MSDA",
    "MSDAU",
    "MSDAW",
    "MSEX",
    "MSFT",
    "MSGM",
    "MSSA",
    "MSSAU",
    "MSSAW",
    "MSTR",
    "MSVB",
    "MTAC",
    "MTACU",
    "MTACW",
    "MTC",
    "MTCH",
    "MTCR",
    "MTEK",
    "MTEKW",
    "MTEM",
    "MTEX",
    "MTLS",
    "MTP",
    "MTRX",
    "MTRY",
    "MTRYW",
    "MTSI",
    "MTTR",
    "MU",
    "MULN",
    "MURF",
    "MURFU",
    "MVBF",
    "MVIS",
    "MVST",
    "MVSTW",
    "MXCT",
    "MXL",
    "MYFW",
    "MYGN",
    "MYMD",
    "MYNA",
    "MYNZ",
    "MYPS",
    "MYPSW",
    "MYRG",
    "MYSZ",
    "NA",
    "NAAC",
    "NAACW",
    "NAAS",
    "NAII",
    "NAMS",
    "NAMSW",
    "NAOV",
    "NARI",
    "NATH",
    "NATI",
    "NATR",
    "NAUT",
    "NAVI",
    "NBIX",
    "NBN",
    "NBRV",
    "NBSE",
    "NBST",
    "NBSTU",
    "NBSTW",
    "NBTB",
    "NBTX",
    "NCAC",
    "NCACU",
    "NCACW",
    "NCMI",
    "NCNA",
    "NCNO",
    "NCPL",
    "NCPLW",
    "NCRA",
    "NCSM",
    "NCTY",
    "NDAQ",
    "NDLS",
    "NDRA",
    "NDSN",
    "NECB",
    "NEGG",
    "NEO",
    "NEOG",
    "NEON",
    "NEOV",
    "NEOVW",
    "NEPH",
    "NEPT",
    "NERV",
    "NESR",
    "NESRW",
    "NEWT",
    "NEWTL",
    "NEWTZ",
    "NEXI",
    "NEXT",
    "NFBK",
    "NFE",
    "NFLX",
    "NGM",
    "NGMS",
    "NH",
    "NHIC",
    "NHICU",
    "NHTC",
    "NICE",
    "NICK",
    "NISN",
    "NIU",
    "NKLA",
    "NKSH",
    "NKTR",
    "NKTX",
    "NLSP",
    "NLSPW",
    "NLTX",
    "NMFC",
    "NMIH",
    "NMRD",
    "NMRK",
    "NMTC",
    "NMTR",
    "NN",
    "NNAVW",
    "NNBR",
    "NNDM",
    "NNOX",
    "NODK",
    "NOGN",
    "NOGNW",
    "NOTV",
    "NOVN",
    "NOVT",
    "NOVV",
    "NOVVR",
    "NPAB",
    "NPABW",
    "NPCE",
    "NRAC",
    "NRACU",
    "NRACW",
    "NRBO",
    "NRC",
    "NRDS",
    "NRIM",
    "NRIX",
    "NRSN",
    "NRSNW",
    "NRXP",
    "NRXPW",
    "NSIT",
    "NSPR",
    "NSSC",
    "NSTG",
    "NSTS",
    "NSYS",
    "NTAP",
    "NTCT",
    "NTES",
    "NTGR",
    "NTIC",
    "NTLA",
    "NTNX",
    "NTRA",
    "NTRB",
    "NTRBW",
    "NTRS",
    "NTRSO",
    "NTWK",
    "NUBI",
    "NUBIU",
    "NUBIW",
    "NURO",
    "NUTX",
    "NUVA",
    "NUVL",
    "NUWE",
    "NUZE",
    "NVAC",
    "NVACR",
    "NVACW",
    "NVAX",
    "NVCN",
    "NVCR",
    "NVCT",
    "NVDA",
    "NVEC",
    "NVEE",
    "NVEI",
    "NVFY",
    "NVIV",
    "NVMI",
    "NVNO",
    "NVOS",
    "NVSA",
    "NVSAU",
    "NVSAW",
    "NVTS",
    "NVVE",
    "NVVEW",
    "NVX",
    "NWBI",
    "NWE",
    "NWFL",
    "NWL",
    "NWLI",
    "NWPX",
    "NWS",
    "NWSA",
    "NWTN",
    "NWTNW",
    "NXGL",
    "NXGLW",
    "NXGN",
    "NXL",
    "NXLIW",
    "NXPI",
    "NXPL",
    "NXPLW",
    "NXST",
    "NXTC",
    "NXTP",
    "NYAX",
    "NYMT",
    "NYMTL",
    "NYMTM",
    "NYMTN",
    "NYMTZ",
    "NYMX",
    "NYXH",
    "OABI",
    "OABIW",
    "OB",
    "OBLG",
    "OBNK",
    "OBSV",
    "OBT",
    "OCAX",
    "OCAXU",
    "OCC",
    "OCCI",
    "OCCIN",
    "OCCIO",
    "OCFC",
    "OCFCP",
    "OCG",
    "OCGN",
    "OCSL",
    "OCUL",
    "OCUP",
    "OCX",
    "ODFL",
    "ODP",
    "OESX",
    "OFED",
    "OFIX",
    "OFLX",
    "OFS",
    "OFSSH",
    "OGI",
    "OHAAU",
    "OHAAW",
    "OIG",
    "OIIM",
    "OKTA",
    "OKYO",
    "OLB",
    "OLED",
    "OLIT",
    "OLK",
    "OLLI",
    "OLMA",
    "OLPX",
    "OM",
    "OMAB",
    "OMCL",
    "OMER",
    "OMEX",
    "OMGA",
    "OMIC",
    "OMQS",
    "ON",
    "ONB",
    "ONBPO",
    "ONBPP",
    "ONCR",
    "ONCS",
    "ONCT",
    "ONCY",
    "ONDS",
    "ONEM",
    "ONEW",
    "ONFO",
    "ONFOW",
    "ONTX",
    "ONVO",
    "ONYX",
    "ONYXU",
    "ONYXW",
    "OP",
    "OPAL",
    "OPBK",
    "OPCH",
    "OPEN",
    "OPGN",
    "OPHC",
    "OPI",
    "OPINL",
    "OPK",
    "OPNT",
    "OPOF",
    "OPRA",
    "OPRT",
    "OPRX",
    "OPT",
    "OPTN",
    "ORGN",
    "ORGNW",
    "ORGO",
    "ORGS",
    "ORIA",
    "ORIAU",
    "ORIAW",
    "ORIC",
    "ORLY",
    "ORMP",
    "ORRF",
    "ORTX",
    "OSA",
    "OSAAW",
    "OSBC",
    "OSIS",
    "OSPN",
    "OSS",
    "OST",
    "OSTK",
    "OSUR",
    "OSW",
    "OTEC",
    "OTECU",
    "OTECW",
    "OTEX",
    "OTLK",
    "OTLY",
    "OTMO",
    "OTMOW",
    "OTRK",
    "OTRKP",
    "OTTR",
    "OVBC",
    "OVID",
    "OVLY",
    "OXAC",
    "OXACW",
    "OXBR",
    "OXBRW",
    "OXLC",
    "OXLCL",
    "OXLCM",
    "OXLCN",
    "OXLCO",
    "OXLCP",
    "OXLCZ",
    "OXSQ",
    "OXSQG",
    "OXSQL",
    "OXSQZ",
    "OXUS",
    "OXUSW",
    "OZK",
    "OZKAP",
    "PAA",
    "PAAS",
    "PACB",
    "PACW",
    "PACWP",
    "PAGP",
    "PAHC",
    "PALI",
    "PALT",
    "PANA",
    "PANL",
    "PANW",
    "PARA",
    "PARAA",
    "PARAP",
    "PASG",
    "PATI",
    "PATK",
    "PAVM",
    "PAVMZ",
    "PAX",
    "PAYA",
    "PAYO",
    "PAYOW",
    "PAYS",
    "PAYX",
    "PBAX",
    "PBAXU",
    "PBAXW",
    "PBBK",
    "PBFS",
    "PBHC",
    "PBLA",
    "PBPB",
    "PBTS",
    "PBYI",
    "PCAR",
    "PCB",
    "PCCT",
    "PCCTW",
    "PCH",
    "PCRX",
    "PCSA",
    "PCT",
    "PCTI",
    "PCTTU",
    "PCTTW",
    "PCTY",
    "PCVX",
    "PCYG",
    "PCYO",
    "PDCE",
    "PDCO",
    "PDD",
    "PDEX",
    "PDFS",
    "PDLB",
    "PDSB",
    "PEAR",
    "PEARW",
    "PEBK",
    "PEBO",
    "PECO",
    "PEGA",
    "PEGR",
    "PEGRU",
    "PEGRW",
    "PEGY",
    "PENN",
    "PEP",
    "PEPG",
    "PEPL",
    "PEPLU",
    "PEPLW",
    "PERI",
    "PESI",
    "PET",
    "PETQ",
    "PETS",
    "PETV",
    "PETVW",
    "PETWW",
    "PETZ",
    "PEV",
    "PFBC",
    "PFC",
    "PFDR",
    "PFDRU",
    "PFDRW",
    "PFG",
    "PFHD",
    "PFIE",
    "PFIN",
    "PFIS",
    "PFMT",
    "PFSW",
    "PFTA",
    "PFTAU",
    "PFX",
    "PFXNZ",
    "PGC",
    "PGEN",
    "PGNY",
    "PGRW",
    "PGRWU",
    "PGRWW",
    "PGY",
    "PGYWW",
    "PHAR",
    "PHAT",
    "PHCF",
    "PHIO",
    "PHUN",
    "PHUNW",
    "PHVS",
    "PI",
    "PIII",
    "PIIIW",
    "PIK",
    "PINC",
    "PIRS",
    "PIXY",
    "PKBK",
    "PKOH",
    "PLAB",
    "PLAO",
    "PLAOU",
    "PLAOW",
    "PLAY",
    "PLBC",
    "PLBY",
    "PLCE",
    "PLL",
    "PLMI",
    "PLMIW",
    "PLMR",
    "PLPC",
    "PLRX",
    "PLSE",
    "PLTK",
    "PLTN",
    "PLTNR",
    "PLTNU",
    "PLTNW",
    "PLUG",
    "PLUR",
    "PLUS",
    "PLXP",
    "PLXS",
    "PLYA",
    "PMCB",
    "PMD",
    "PMGM",
    "PMGMU",
    "PMGMW",
    "PMN",
    "PMTS",
    "PMVP",
    "PNAC",
    "PNACR",
    "PNACU",
    "PNACW",
    "PNBK",
    "PNFP",
    "PNFPP",
    "PNRG",
    "PNT",
    "PNTG",
    "POAI",
    "POCI",
    "PODD",
    "POET",
    "POLA",
    "PONO",
    "PONOU",
    "PONOW",
    "POOL",
    "POWI",
    "POWL",
    "POWW",
    "POWWP",
    "PPBI",
    "PPBT",
    "PPC",
    "PPHP",
    "PPHPR",
    "PPHPU",
    "PPHPW",
    "PPIH",
    "PPSI",
    "PPTA",
    "PPYA",
    "PPYAU",
    "PPYAW",
    "PRAA",
    "PRAX",
    "PRCH",
    "PRCT",
    "PRDO",
    "PRDS",
    "PRE",
    "PRENW",
    "PRFT",
    "PRFX",
    "PRGS",
    "PRIM",
    "PRLD",
    "PRLH",
    "PRLHU",
    "PRLHW",
    "PRME",
    "PROC",
    "PROCW",
    "PROF",
    "PROK",
    "PROV",
    "PRPH",
    "PRPL",
    "PRPO",
    "PRQR",
    "PRSO",
    "PRSR",
    "PRSRU",
    "PRSRW",
    "PRST",
    "PRSTW",
    "PRTA",
    "PRTC",
    "PRTG",
    "PRTH",
    "PRTK",
    "PRTS",
    "PRVA",
    "PRVB",
    "PSEC",
    "PSHG",
    "PSMT",
    "PSNL",
    "PSNY",
    "PSNYW",
    "PSTV",
    "PSTX",
    "PT",
    "PTC",
    "PTCT",
    "PTE",
    "PTEN",
    "PTGX",
    "PTIX",
    "PTLO",
    "PTMN",
    "PTNR",
    "PTOC",
    "PTOCW",
    "PTON",
    "PTPI",
    "PTRA",
    "PTRS",
    "PTSI",
    "PTVE",
    "PTWO",
    "PTWOU",
    "PTWOW",
    "PUBM",
    "PUCK",
    "PUCKU",
    "PUCKW",
    "PULM",
    "PUYI",
    "PVBC",
    "PWFL",
    "PWOD",
    "PWP",
    "PWUP",
    "PWUPU",
    "PWUPW",
    "PXLW",
    "PXMD",
    "PXS",
    "PXSAP",
    "PXSAW",
    "PYCR",
    "PYPD",
    "PYPL",
    "PYR",
    "PYXS",
    "PZZA",
    "QCOM",
    "QCRH",
    "QDEL",
    "QFIN",
    "QH",
    "QIPT",
    "QLGN",
    "QLI",
    "QLYS",
    "QMCO",
    "QNCX",
    "QNRX",
    "QNST",
    "QOMO",
    "QOMOR",
    "QOMOU",
    "QQQX",
    "QRHC",
    "QRTEA",
    "QRTEB",
    "QRTEP",
    "QRVO",
    "QSG",
    "QSI",
    "QSIAW",
    "QTEK",
    "QTEKW",
    "QTRX",
    "QTT",
    "QUBT",
    "QUIK",
    "QUMU",
    "QURE",
    "RADI",
    "RAIL",
    "RAIN",
    "RAM",
    "RAMMU",
    "RAMMW",
    "RAND",
    "RANI",
    "RAPT",
    "RARE",
    "RAVE",
    "RAYA",
    "RBB",
    "RBBN",
    "RBCAA",
    "RBKB",
    "RCAC",
    "RCAT",
    "RCEL",
    "RCII",
    "RCKT",
    "RCKY",
    "RCLF",
    "RCLFU",
    "RCM",
    "RCMT",
    "RCON",
    "RCRT",
    "RDCM",
    "RDFN",
    "RDHL",
    "RDI",
    "RDIB",
    "RDNT",
    "RDVT",
    "RDWR",
    "REAL",
    "REAX",
    "REBN",
    "REE",
    "REED",
    "REFI",
    "REFR",
    "REG",
    "REGN",
    "REKR",
    "RELI",
    "RELIW",
    "RELL",
    "RELY",
    "RENE",
    "RENEU",
    "RENEW",
    "RENT",
    "REPL",
    "RETA",
    "RETO",
    "REUN",
    "REVB",
    "REVBW",
    "REVE",
    "REYN",
    "RFAC",
    "RFACU",
    "RFIL",
    "RGC",
    "RGCO",
    "RGEN",
    "RGF",
    "RGLD",
    "RGLS",
    "RGNX",
    "RGP",
    "RGTI",
    "RGTIW",
    "RIBT",
    "RICK",
    "RIDE",
    "RIGL",
    "RILY",
    "RILYG",
    "RILYK",
    "RILYL",
    "RILYM",
    "RILYN",
    "RILYO",
    "RILYP",
    "RILYT",
    "RILYZ",
    "RIOT",
    "RIVN",
    "RKDA",
    "RKLB",
    "RLAY",
    "RLMD",
    "RLYB",
    "RMBI",
    "RMBL",
    "RMBS",
    "RMCF",
    "RMGC",
    "RMGCU",
    "RMGCW",
    "RMNI",
    "RMR",
    "RMTI",
    "RNA",
    "RNAZ",
    "RNER",
    "RNERU",
    "RNERW",
    "RNLX",
    "RNST",
    "RNW",
    "RNWWW",
    "RNXT",
    "ROAD",
    "ROC",
    "ROCC",
    "ROCG",
    "ROCGU",
    "ROCGW",
    "ROCK",
    "ROCL",
    "ROCLU",
    "ROCLW",
    "ROIC",
    "ROIV",
    "ROIVW",
    "ROKU",
    "ROOT",
    "ROSE",
    "ROSEU",
    "ROSEW",
    "ROST",
    "ROVR",
    "RPAY",
    "RPD",
    "RPHM",
    "RPID",
    "RPRX",
    "RPTX",
    "RRBI",
    "RRGB",
    "RRR",
    "RSLS",
    "RSSS",
    "RSVR",
    "RSVRW",
    "RTC",
    "RTL",
    "RTLPO",
    "RTLPP",
    "RUBY",
    "RUM",
    "RUMBW",
    "RUN",
    "RUSHA",
    "RUSHB",
    "RUTH",
    "RVLP",
    "RVMD",
    "RVNC",
    "RVPH",
    "RVPHW",
    "RVSB",
    "RVSN",
    "RVSNW",
    "RVYL",
    "RWAY",
    "RWAYL",
    "RWAYZ",
    "RWLK",
    "RWOD",
    "RWODR",
    "RXDX",
    "RXRX",
    "RXST",
    "RXT",
    "RYAAY",
    "RYTM",
    "RZLT",
    "SABR",
    "SABRP",
    "SABS",
    "SABSW",
    "SAFT",
    "SAGA",
    "SAGAR",
    "SAGE",
    "SAI",
    "SAIA",
    "SAITW",
    "SAL",
    "SALM",
    "SAMA",
    "SAMAU",
    "SAMAW",
    "SAMG",
    "SANA",
    "SANG",
    "SANM",
    "SANW",
    "SASI",
    "SASR",
    "SATL",
    "SATS",
    "SAVA",
    "SBAC",
    "SBCF",
    "SBET",
    "SBFG",
    "SBFM",
    "SBFMW",
    "SBGI",
    "SBIG",
    "SBIGW",
    "SBLK",
    "SBNY",
    "SBNYP",
    "SBRA",
    "SBSI",
    "SBT",
    "SBUX",
    "SCAQ",
    "SCAQU",
    "SCHL",
    "SCHN",
    "SCKT",
    "SCLX",
    "SCLXW",
    "SCMA",
    "SCMAW",
    "SCOB",
    "SCOBU",
    "SCOBW",
    "SCOR",
    "SCPH",
    "SCPL",
    "SCRM",
    "SCRMU",
    "SCRMW",
    "SCSC",
    "SCTL",
    "SCVL",
    "SCWO",
    "SCWX",
    "SCYX",
    "SDAC",
    "SDACU",
    "SDACW",
    "SDC",
    "SDGR",
    "SDIG",
    "SEAC",
    "SEAT",
    "SECO",
    "SEDG",
    "SEED",
    "SEEL",
    "SEER",
    "SEIC",
    "SELB",
    "SELF",
    "SENEA",
    "SENEB",
    "SERA",
    "SESN",
    "SEV",
    "SEVN",
    "SFBC",
    "SFE",
    "SFIX",
    "SFM",
    "SFNC",
    "SFR",
    "SFRWW",
    "SFST",
    "SFT",
    "SGA",
    "SGBX",
    "SGC",
    "SGEN",
    "SGH",
    "SGHL",
    "SGHLU",
    "SGHLW",
    "SGHT",
    "SGII",
    "SGIIW",
    "SGLY",
    "SGMA",
    "SGML",
    "SGMO",
    "SGRP",
    "SGRY",
    "SGTX",
    "SHBI",
    "SHC",
    "SHCR",
    "SHCRW",
    "SHEN",
    "SHFS",
    "SHFSW",
    "SHIP",
    "SHLS",
    "SHOO",
    "SHPH",
    "SHUA",
    "SHUAU",
    "SHYF",
    "SIBN",
    "SIDU",
    "SIEB",
    "SIEN",
    "SIFY",
    "SIGA",
    "SIGI",
    "SIGIP",
    "SILC",
    "SILK",
    "SILO",
    "SIMO",
    "SINT",
    "SIOX",
    "SIRI",
    "SISI",
    "SITM",
    "SIVB",
    "SIVBP",
    "SJ",
    "SKGR",
    "SKGRU",
    "SKGRW",
    "SKIN",
    "SKWD",
    "SKYA",
    "SKYAU",
    "SKYAW",
    "SKYT",
    "SKYW",
    "SKYX",
    "SLAB",
    "SLAC",
    "SLACU",
    "SLACW",
    "SLAM",
    "SLAMU",
    "SLAMW",
    "SLDB",
    "SLDP",
    "SLDPW",
    "SLGC",
    "SLGCW",
    "SLGG",
    "SLGL",
    "SLM",
    "SLMBP",
    "SLN",
    "SLNA",
    "SLNAW",
    "SLNG",
    "SLNH",
    "SLNHP",
    "SLNO",
    "SLP",
    "SLRC",
    "SLRX",
    "SLS",
    "SLVR",
    "SLVRW",
    "SMAP",
    "SMAPU",
    "SMAPW",
    "SMBC",
    "SMBK",
    "SMCI",
    "SMFL",
    "SMID",
    "SMIH",
    "SMIHW",
    "SMLR",
    "SMMF",
    "SMMT",
    "SMPL",
    "SMSI",
    "SMTC",
    "SMTI",
    "SNAL",
    "SNAX",
    "SNAXW",
    "SNBR",
    "SNCE",
    "SNCR",
    "SNCRL",
    "SNCY",
    "SND",
    "SNDL",
    "SNDX",
    "SNES",
    "SNEX",
    "SNFCA",
    "SNGX",
    "SNOA",
    "SNPO",
    "SNPS",
    "SNPX",
    "SNRH",
    "SNRHU",
    "SNRHW",
    "SNSE",
    "SNT",
    "SNTG",
    "SNTI",
    "SNY",
    "SOBR",
    "SOFI",
    "SOFO",
    "SOHO",
    "SOHOB",
    "SOHON",
    "SOHOO",
    "SOHU",
    "SOLO",
    "SOLOW",
    "SOND",
    "SONDW",
    "SONM",
    "SONN",
    "SONO",
    "SOPA",
    "SOPH",
    "SOTK",
    "SOUN",
    "SOUNW",
    "SOVO",
    "SP",
    "SPCB",
    "SPCM",
    "SPCMU",
    "SPCMW",
    "SPFI",
    "SPI",
    "SPKB",
    "SPKBU",
    "SPKBW",
    "SPLK",
    "SPNS",
    "SPOK",
    "SPPI",
    "SPRB",
    "SPRC",
    "SPRO",
    "SPRY",
    "SPSC",
    "SPT",
    "SPTN",
    "SPWH",
    "SPWR",
    "SQFT",
    "SQFTP",
    "SQFTW",
    "SQL",
    "SQLLW",
    "SRAD",
    "SRAX",
    "SRCE",
    "SRCL",
    "SRDX",
    "SRGA",
    "SRNE",
    "SRPT",
    "SRRK",
    "SRTS",
    "SRZN",
    "SRZNW",
    "SSB",
    "SSBI",
    "SSBK",
    "SSIC",
    "SSKN",
    "SSNC",
    "SSNT",
    "SSP",
    "SSRM",
    "SSSS",
    "SSSSL",
    "SSTI",
    "SSYS",
    "STAA",
    "STAF",
    "STBA",
    "STBX",
    "STCN",
    "STEL",
    "STEP",
    "STER",
    "STGW",
    "STIM",
    "STIX",
    "STIXW",
    "STKH",
    "STKL",
    "STKS",
    "STLD",
    "STNE",
    "STOK",
    "STRA",
    "STRC",
    "STRCW",
    "STRL",
    "STRM",
    "STRO",
    "STRR",
    "STRRP",
    "STRS",
    "STRT",
    "STSA",
    "STSS",
    "STSSW",
    "STTK",
    "STX",
    "SUMO",
    "SUNW",
    "SUPN",
    "SURF",
    "SURG",
    "SURGW",
    "SVC",
    "SVFA",
    "SVFAU",
    "SVFAW",
    "SVFB",
    "SVFD",
    "SVII",
    "SVIIR",
    "SVIIU",
    "SVIIW",
    "SVNA",
    "SVNAU",
    "SVNAW",
    "SVRA",
    "SVRE",
    "SVVC",
    "SWAG",
    "SWAGW",
    "SWAV",
    "SWBI",
    "SWIM",
    "SWKH",
    "SWKS",
    "SWSS",
    "SWSSU",
    "SWSSW",
    "SWTX",
    "SWVL",
    "SWVLW",
    "SXTC",
    "SY",
    "SYBT",
    "SYBX",
    "SYM",
    "SYNA",
    "SYNH",
    "SYPR",
    "SYRS",
    "SYTA",
    "SYTAW",
    "SZZL",
    "SZZLU",
    "SZZLW",
    "TA",
    "TACT",
    "TAIT",
    "TALK",
    "TALKW",
    "TALS",
    "TANH",
    "TANNI",
    "TANNL",
    "TANNZ",
    "TAOP",
    "TARA",
    "TARS",
    "TASK",
    "TAST",
    "TATT",
    "TAYD",
    "TBBK",
    "TBCP",
    "TBCPU",
    "TBCPW",
    "TBIO",
    "TBLA",
    "TBLAW",
    "TBLD",
    "TBLT",
    "TBLTW",
    "TBNK",
    "TBPH",
    "TBSA",
    "TBSAU",
    "TBSAW",
    "TC",
    "TCBC",
    "TCBI",
    "TCBIO",
    "TCBK",
    "TCBP",
    "TCBPW",
    "TCBS",
    "TCBX",
    "TCFC",
    "TCMD",
    "TCOM",
    "TCON",
    "TCPC",
    "TCRR",
    "TCRT",
    "TCRX",
    "TCVA",
    "TCX",
    "TDUP",
    "TEAM",
    "TECH",
    "TECTP",
    "TEDU",
    "TELA",
    "TENB",
    "TENK",
    "TENKU",
    "TENX",
    "TER",
    "TERN",
    "TESS",
    "TETC",
    "TETCU",
    "TETCW",
    "TETE",
    "TETEU",
    "TFFP",
    "TFIN",
    "TFINP",
    "TFSL",
    "TGAA",
    "TGAAU",
    "TGAAW",
    "TGAN",
    "TGL",
    "TGTX",
    "TGVC",
    "TH",
    "THCH",
    "THCHW",
    "THCP",
    "THCPU",
    "THCPW",
    "THFF",
    "THMO",
    "THRD",
    "THRM",
    "THRN",
    "THRX",
    "THRY",
    "THTX",
    "THWWW",
    "TIG",
    "TIGO",
    "TIGR",
    "TIL",
    "TILE",
    "TIOA",
    "TIOAU",
    "TIOAW",
    "TIPT",
    "TIRX",
    "TITN",
    "TIVC",
    "TKLF",
    "TKNO",
    "TLF",
    "TLGY",
    "TLGYU",
    "TLGYW",
    "TLIS",
    "TLRY",
    "TLS",
    "TLSA",
    "TMC",
    "TMCI",
    "TMCWW",
    "TMDI",
    "TMDX",
    "TMKR",
    "TMKRU",
    "TMKRW",
    "TMPO",
    "TMPOW",
    "TMUS",
    "TNDM",
    "TNGX",
    "TNON",
    "TNXP",
    "TNYA",
    "TOAC",
    "TOACW",
    "TOI",
    "TOIIW",
    "TOMZ",
    "TOP",
    "TOPS",
    "TOUR",
    "TOWN",
    "TPBA",
    "TPBAU",
    "TPBAW",
    "TPG",
    "TPIC",
    "TPST",
    "TRDA",
    "TREE",
    "TRHC",
    "TRIB",
    "TRIN",
    "TRINL",
    "TRIP",
    "TRKA",
    "TRKAW",
    "TRMB",
    "TRMD",
    "TRMK",
    "TRMR",
    "TRNS",
    "TRON",
    "TROO",
    "TROW",
    "TRS",
    "TRST",
    "TRUE",
    "TRUP",
    "TRVG",
    "TRVI",
    "TRVN",
    "TSAT",
    "TSBK",
    "TSCO",
    "TSEM",
    "TSHA",
    "TSLA",
    "TSP",
    "TSRI",
    "TSVT",
    "TTCF",
    "TTD",
    "TTEC",
    "TTEK",
    "TTGT",
    "TTMI",
    "TTNP",
    "TTOO",
    "TTSH",
    "TTWO",
    "TURN",
    "TUSK",
    "TVTX",
    "TW",
    "TWCB",
    "TWCBU",
    "TWCBW",
    "TWIN",
    "TWKS",
    "TWLV",
    "TWNK",
    "TWOU",
    "TWST",
    "TXG",
    "TXMD",
    "TXN",
    "TXRH",
    "TYDE",
    "TYRA",
    "TZOO",
    "UAL",
    "UBCP",
    "UBFO",
    "UBSI",
    "UBX",
    "UCBI",
    "UCBIO",
    "UCL",
    "UCTT",
    "UDMY",
    "UEIC",
    "UFCS",
    "UFPI",
    "UFPT",
    "UG",
    "UGRO",
    "UIHC",
    "UK",
    "UKOMW",
    "ULBI",
    "ULCC",
    "ULH",
    "ULTA",
    "UMBF",
    "UMPQ",
    "UNAM",
    "UNB",
    "UNCY",
    "UNIT",
    "UNTY",
    "UONE",
    "UONEK",
    "UPC",
    "UPLD",
    "UPST",
    "UPTD",
    "UPTDU",
    "UPTDW",
    "UPWK",
    "UPXI",
    "URBN",
    "URGN",
    "UROY",
    "USAP",
    "USAU",
    "USCB",
    "USCT",
    "USCTU",
    "USCTW",
    "USEA",
    "USEG",
    "USIO",
    "USLM",
    "UTAA",
    "UTAAU",
    "UTAAW",
    "UTHR",
    "UTMD",
    "UTME",
    "UTRS",
    "UTSI",
    "UVSP",
    "UXIN",
    "VABK",
    "VACC",
    "VALN",
    "VALU",
    "VANI",
    "VAQC",
    "VAXX",
    "VBFC",
    "VBIV",
    "VBLT",
    "VBNK",
    "VBOC",
    "VBTX",
    "VC",
    "VCEL",
    "VCNX",
    "VCSA",
    "VCTR",
    "VCXA",
    "VCXAU",
    "VCXAW",
    "VCYT",
    "VECO",
    "VECT",
    "VEDU",
    "VEEE",
    "VEON",
    "VERA",
    "VERB",
    "VERBW",
    "VERI",
    "VERO",
    "VERU",
    "VERV",
    "VERX",
    "VERY",
    "VEV",
    "VFF",
    "VHNA",
    "VHNAW",
    "VIA",
    "VIASP",
    "VIAV",
    "VICR",
    "VIEW",
    "VIEWW",
    "VIGL",
    "VII",
    "VINC",
    "VINO",
    "VINP",
    "VIOT",
    "VIR",
    "VIRC",
    "VIRI",
    "VIRT",
    "VIRX",
    "VISL",
    "VITL",
    "VIVK",
    "VIVO",
    "VJET",
    "VKTX",
    "VLAT",
    "VLATU",
    "VLATW",
    "VLCN",
    "VLDR",
    "VLDRW",
    "VLGEA",
    "VLON",
    "VLY",
    "VLYPO",
    "VLYPP",
    "VMAR",
    "VMCA",
    "VMCAU",
    "VMCAW",
    "VMD",
    "VMEO",
    "VMGA",
    "VMGAW",
    "VNDA",
    "VNET",
    "VNOM",
    "VOD",
    "VOR",
    "VORB",
    "VORBW",
    "VOXR",
    "VOXX",
    "VPCB",
    "VPCBU",
    "VPCBW",
    "VQS",
    "VRA",
    "VRAR",
    "VRAX",
    "VRAY",
    "VRCA",
    "VRDN",
    "VREX",
    "VRM",
    "VRME",
    "VRMEW",
    "VRNA",
    "VRNS",
    "VRNT",
    "VRPX",
    "VRRM",
    "VRSK",
    "VRSN",
    "VRTS",
    "VRTX",
    "VS",
    "VSAC",
    "VSACU",
    "VSACW",
    "VSAT",
    "VSEC",
    "VSTA",
    "VSTM",
    "VTGN",
    "VTNR",
    "VTRS",
    "VTRU",
    "VTSI",
    "VTVT",
    "VTYX",
    "VUZI",
    "VVOS",
    "VVPR",
    "VWE",
    "VWEWW",
    "VXRT",
    "VYGR",
    "VYNE",
    "VYNT",
    "WABC",
    "WAFD",
    "WAFDP",
    "WAFU",
    "WALD",
    "WALDW",
    "WASH",
    "WATT",
    "WAVD",
    "WAVE",
    "WAVS",
    "WAVSU",
    "WB",
    "WBA",
    "WBD",
    "WDAY",
    "WDC",
    "WDFC",
    "WEJO",
    "WEJOW",
    "WEN",
    "WERN",
    "WEST",
    "WESTW",
    "WETG",
    "WEYS",
    "WFCF",
    "WFRD",
    "WGS",
    "WGSWW",
    "WHF",
    "WHLM",
    "WHLR",
    "WHLRD",
    "WHLRL",
    "WHLRP",
    "WILC",
    "WIMI",
    "WINA",
    "WING",
    "WINT",
    "WINV",
    "WIRE",
    "WISA",
    "WISH",
    "WIX",
    "WKEY",
    "WKHS",
    "WKME",
    "WKSP",
    "WKSPW",
    "WLDN",
    "WLDS",
    "WLDSW",
    "WLFC",
    "WMG",
    "WMPN",
    "WNEB",
    "WNW",
    "WOOF",
    "WORX",
    "WPRT",
    "WRAP",
    "WRLD",
    "WSBC",
    "WSBCP",
    "WSBF",
    "WSC",
    "WSFS",
    "WTBA",
    "WTER",
    "WTFC",
    "WTFCM",
    "WTFCP",
    "WTMA",
    "WTW",
    "WULF",
    "WVE",
    "WVVI",
    "WVVIP",
    "WW",
    "WWAC",
    "WWACU",
    "WWACW",
    "WWD",
    "WYNN",
    "XAIR",
    "XBIO",
    "XBIOW",
    "XBIT",
    "XCUR",
    "XEL",
    "XELA",
    "XELAP",
    "XELB",
    "XENE",
    "XERS",
    "XFIN",
    "XFINU",
    "XFOR",
    "XGN",
    "XLO",
    "XM",
    "XMTR",
    "XNCR",
    "XNET",
    "XOMA",
    "XOMAO",
    "XOMAP",
    "XOS",
    "XOSWW",
    "XP",
    "XPAX",
    "XPAXU",
    "XPAXW",
    "XPDB",
    "XPDBU",
    "XPDBW",
    "XPEL",
    "XPON",
    "XRAY",
    "XRTX",
    "XRX",
    "XTLB",
    "XWEL",
    "XXII",
    "YELL",
    "YGMZ",
    "YI",
    "YJ",
    "YMAB",
    "YORW",
    "YOSH",
    "YOTA",
    "YOTAR",
    "YOTAU",
    "YOTAW",
    "YQ",
    "YTEN",
    "YTRA",
    "YVR",
    "YY",
    "Z",
    "ZBRA",
    "ZCMD",
    "ZD",
    "ZENV",
    "ZEST",
    "ZEUS",
    "ZFOX",
    "ZFOXW",
    "ZG",
    "ZI",
    "ZIMV",
    "ZING",
    "ZINGW",
    "ZION",
    "ZIONL",
    "ZIONO",
    "ZIONP",
    "ZIVO",
    "ZIVOW",
    "ZKIN",
    "ZLAB",
    "ZM",
    "ZNTL",
    "ZS",
    "ZT",
    "ZTAQU",
    "ZTAQW",
    "ZTEK",
    "ZUMZ",
    "ZVSA",
    "ZYME",
    "ZYNE",
    "ZYXI",
  ],
];

export const modifiedTickerSymbolArray = stocksTickerSymobols[0].map((item, i) => [
  {
    id: i,
    item: item,
    added: false,
  },
]);

export const API_KEY = "cf9de42ad3i2irjr5ckgcf9de42ad3i2irjr5cl0";
 

export function bounceEase(x) {
  const n1 = 7.5625;
  const d1 = 2.75;

  if (x < 1 / d1) {
    return n1 * x * x;
  } else if (x < 2 / d1) {
    return n1 * (x -= 1.5 / d1) * x + 0.75;
  } else if (x < 2.5 / d1) {
    return n1 * (x -= 2.25 / d1) * x + 0.9375;
  } else {
    return n1 * (x -= 2.625 / d1) * x + 0.984375;
  }
}